interface ResultSession {
  readonly accessToken: string;
  readonly expiresAt: string;
}

const STORAGE_KEY = "carepass.termination.result-session";
let memorySession: ResultSession | undefined;
let memoryOnly = false;

export function saveTerminationResultSession(accessToken: string, expiresAt: string): boolean {
  if (!accessToken || !Number.isFinite(Date.parse(expiresAt)) || Date.parse(expiresAt) <= Date.now()) return false;
  memorySession = { accessToken, expiresAt };
  try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(memorySession)); memoryOnly = false; } catch { memoryOnly = true; }
  return true;
}

export function readTerminationResultSession(now = Date.now()): ResultSession | undefined {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      let value: unknown;
      try { value = JSON.parse(stored); } catch { memorySession = undefined; }
      if (typeof value === "object" && value !== null && "accessToken" in value && "expiresAt" in value &&
        typeof value.accessToken === "string" && typeof value.expiresAt === "string") memorySession = { accessToken: value.accessToken, expiresAt: value.expiresAt };
      else memorySession = undefined;
    } else if (!memoryOnly) memorySession = undefined;
  } catch { /* Retain the in-memory capability when storage itself is unavailable. */ }
  if (memorySession?.accessToken && Date.parse(memorySession.expiresAt) > now) return memorySession;
  clearTerminationResultSession();
  return undefined;
}

export function clearTerminationResultSession() {
  memorySession = undefined;
  memoryOnly = false;
  try { sessionStorage.removeItem(STORAGE_KEY); } catch { /* No persistent session exists when storage is unavailable. */ }
}
